"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Check } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface FormSuccessStateProps {
  message: string;
  children?: ReactNode;
  className?: string;
}

export function FormSuccessState({
  message,
  children,
  className,
}: FormSuccessStateProps) {
  const reduced = useReducedMotion();

  return (
    <motion.div
      initial={reduced ? false : { opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      className={cn(
        "rounded-xl border border-primary/30 bg-surface-accent p-6 text-center",
        className
      )}
    >
      <motion.div
        initial={reduced ? false : { scale: 0 }}
        animate={{ scale: 1 }}
        transition={{
          delay: reduced ? 0 : 0.1,
          type: "spring",
          stiffness: 260,
          damping: 18,
        }}
        className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary/15 text-primary"
      >
        <Check size={24} aria-hidden />
      </motion.div>
      <p className="font-medium text-primary">{message}</p>
      {children && <div className="mt-3">{children}</div>}
    </motion.div>
  );
}
